import {
	clearCurrentTree,
	clearRehabTreesDefault,
	getAssetFilters,
	getRehabTreesList,
} from '@Actions/Rehab.actions';
import { selectIsLoading } from '@Selectors/Rehab.selectors';
import { FullPage, FullPageWrapper } from '@Utils/styles';
import React, { useEffect } from 'react';
import { Link, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import RehabTreeList from '@Components/RehabTreeList';
import { HelpPageDrawer, HELP_DRAWER } from '@Components/HelpPageDrawer';
import { openDrawer } from '@innovyze/stylovyze';
import { useGlobalization } from '@Translations';
const RehabManagement = () => {
	const { t } = useGlobalization();
	const dispatch = useDispatch();

	// const rehabTrees = selectRehabTrees();
	useEffect(() => {
		dispatch(getAssetFilters());
	}, []);
	useEffect(() => {
		dispatch(clearCurrentTree());
		dispatch(clearRehabTreesDefault());
		dispatch(getRehabTreesList());
	}, []);

	const isLoading = selectIsLoading();

	const rehabTreeListTab = () => {
		return (
			<FullPage>
				<RehabTreeList />
			</FullPage>
		);
	};

	const secondaryNav = () => {
		const tabs = [
			{ content: rehabTreeListTab(), title: t('Decision Trees') },
		];

		return tabs;
	};

	return (
		<FullPageWrapper
			isLoading={isLoading}
			title={t('Rehab Decision Trees')}
			applyPadding={true}
			headerUnderline
			breadcrumbs={[{ title: t('Analysis'), link: '/analysis' }]}
			subHeader={
				<Typography variant="body1">
					{t(
						'Build rule-based trees that assign rehab actions to assets based on condition, risk, and other factors.',
					)}{' '}
					<Link
						style={{ cursor: 'pointer', textDecoration: 'none' }}
						onClick={() => {
							dispatch(
								openDrawer(HELP_DRAWER.DECISION_TREES_OVERVIEW),
							);
						}}>
						{t('Learn more about Decision Trees')}
					</Link>
				</Typography>
			}
			secondaryNav={{
				items: secondaryNav(),
				itemIndex: 0,
			}}>
			<HelpPageDrawer drawerID={HELP_DRAWER.DECISION_TREES_OVERVIEW} />
		</FullPageWrapper>
	);
};
export default RehabManagement;
